import { Col } from 'antd';
import styled from 'styled-components';

export const FiledColDivider = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
